export { OverlayTarget, OverlayDialogBoundary, DefaultOverlayTarget } from './overlay.directives';
export { ModalOverlay } from './overlay.component';
export { Overlay } from './overlay.service';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-modal/esm/overlay/index.js
// module id = 54
// module chunks = 3